import { render, staticRenderFns } from "./Step5CancelInsurance.vue?vue&type=template&id=184f809a&"
import script from "./Step5CancelInsurance.vue?vue&type=script&lang=js&"
export * from "./Step5CancelInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports